var generateStyle = function generateStyle() {
  return {
    metricLabel: {
      margin: 0,
      maxWidth: '159px',
      textTransform: 'capitalize'
    },
    metricWrapper: {
      width: '90px'
    }
  };
};
export default generateStyle;